// Services
import { asyncResource } from '../../utils/services/http/asyncResource/asyncResource';
import http from '../../utils/services/http';

// Actions
import { loadElements } from '../../element/actions/elementActions';
import { fetchBoards } from '../../element/board/boardService';

// Constants
import { ResourceTypes } from '../../utils/services/http/asyncResource/asyncResourceConstants';

// Types
import { CurrentUserNavigationHistoryGetResponse } from '../../../common/api/users/me/currentUserRoutesTypes';

const fetchHistory = (limit = 20) =>
    http<never, CurrentUserNavigationHistoryGetResponse>({
        url: 'users/me/history',
        params: {
            limit,
        },
    });

export const fetchNavigationHistory =
    (limit = 20) =>
    async (dispatch: Function): Promise<void> => {
        await dispatch(
            asyncResource(ResourceTypes.history)(async () => {
                const response = await fetchHistory(limit);

                const { history, elements } = response.data;

                // Load elements into the store
                dispatch(loadElements(elements));

                const boardIds = history.map((historyEntry) => historyEntry.elementId);
                await dispatch(
                    fetchBoards({
                        boardIds,
                    }),
                );

                return {
                    asyncResource: {},
                    history,
                };
            }),
        );
    };
